import styled from 'styled-components';
import { zIndexCSS } from '../head-cell/styled';
import { getSizeBy } from '../../../../../src/styled/utils';
export const StyledHead = styled.thead `
  top: 0;
  ${({ $isBlock }) => $isBlock && zIndexCSS}

  & tr:hover {
    background-color: initial;
  }
`;
export const StyledHeadCellToolbar = styled.th `
  padding: 0 ${getSizeBy(4)} ${getSizeBy(4)};
`;
export const ToolbarWrap = styled.div `
  display: flex;
  flex-flow: row nowrap;
`;
export const ActionsBlock = styled.div `
  margin-left: auto;
`;
